// extracted by mini-css-extract-plugin
export default {"infraL3":"InfraL3_infraL3__bsLId","pieGraph":"InfraL3_pieGraph__L8a4p","graph":"InfraL3_graph__wA5dg"};